// extracted by mini-css-extract-plugin
export var closeButton = "_3o-3";
export var header = "_3o-0";
export var link = "_3o-1";
export var retryButton = "_3o-2";